export default __webpack_public_path__ + "static/agnitio-logo.e95c6f0b.svg";